module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fmtitle"
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }, [_c('span', {
    staticClass: "bb"
  }, [_vm._v("Illustrations")])])]), _c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/03_Fm01#fig1",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Last Words of Captain Nathan Hale")]), _vm._v(" | frontispiece")])]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/11_Fm03#fig2"
    }
  }, [_c('i', [_vm._v("The Battle-Fields of South Carolina 1775–1780")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/13_Part01#fig3"
    }
  }, [_vm._v("Sir Henry Clinton, engraving")])]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/14_Chapter01#fig4"
    }
  }, [_c('i', [_vm._v("The most Noble Marquis Cornwallis, K.G")])]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter02#fig5",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("David Ramsay, M.D")])]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter02#fig6",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Francis Lord Rawdon")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter03#fig7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Colleton District, South Carolina/A Map of South Carolina and a Part of Georgia")])]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Part02#fig8",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Isaac Hayne, Carolina Patriot")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter04#fig9",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Richard Hutson, Member of the Continental Congress")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter04#fig10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The grave of Elizabeth Hutson Hayne")])]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter05#fig11",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Capture of Hayne and Death of M’Laughlin")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter05#fig12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Royal Exchange and Customs House")])]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter05#fig13",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("The Unfortunate Death of Major André")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter05#fig14",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Isaac Hayne Being Led from the Exchange to the Scaffold")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter06#fig15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The grave of Col. Isaac Hayne")])]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter06#fig16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Nathanael Greene, engraving")])]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Chapter07#fig17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lt. Col. Nisbet Balfour’s dispatch")])]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/22_Part03#fig18",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Francis Lord Rawdon, Marquis of Hastings")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/23_Chapter08#fig19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Hayne family cemetery")])]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/24_Chapter09#fig20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Isaac Hayne monument")])]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/25_Chapter10#fig21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fictionalized portrait of Lt. Colonel Nisbet Balfour")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41adf91f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/08_ListofIll.vue
// module id = 78
// module chunks = 0